export const LOADER_DELAY: number = 500;
